import _ from 'lodash';
import { createFsDocKey_alt } from '../../../global/firestoreData/appData/fsAppData';
import { seasonalUpdateTypes } from '../cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { _mediaHeaders } from '../cnr/reducers/SportsDataReducer';
import { gameScoringTypes } from '../cnr/reducers/SportsSeasonReducer';
import { sgs } from '../helpers/scheduleGrids';
import { seasonalHelpers } from '../cnr/reducers/reducerHelpers/seasonalHelpers';

export const updateScheduledMatches = async (database_fns, paps_state, latestSeason, scheduleProps, callback) => {

  const { pathViews } = paps_state
  const pks = seasonalHelpers.getPks(pathViews, latestSeason)
  // updates `_seasonals`

  const _updateProps = seasonalHelpers.getUpdateProps(database_fns, pathViews, pks, callback, null, 'matches', scheduleProps.matches_combined)
  seasonalHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps)

}

// {gridMatches, teams, matches, sectionDates, crossSectionDates, homeAways, gameScoringType} 
export const createScheduledMatches = (database_fns, mainDb, seasonMatchesProps) => {

  const { gridMatches, teams, matches, sectionDates, crossSectionDates, sectionCrossovers, homeAways, gameScoringType } = seasonMatchesProps ?? {}

  const allM = {}
  const allCM = {}

  const levels = _.groupBy(teams, 'levels')
  const sportInfo = { startTime: '7:00 PM' }

  if (gridMatches) {
    gridMatches.forEach(gm => {
      const _key = database_fns.get_docKey()
      allM[_key] = {
        startDate: gm.startDate ? gm.startDate : '?????',
        startTime: '7:00 PM',
        home: gm.home,
        away: gm.away,
        levels: gm.levels,
        sections: gm.sections,
        teams: [gm.home.id, gm.away.id],
        key: gm.away.name + '-' + gm.home.name
      }
    })
  } else {

    const crossoverKeys = []

    _.forEach(levels, (level, levelKey) => {
      const sections = _.groupBy(level, 'sections')
      _.forEach(sections, (sectionTeams, sectionKey) => {
        const _levelSectionKey = levelKey + '_' + sectionKey
        // const _homeAway = true // homeAways[_levelSectionKey]
        const _homeAway = homeAways[_levelSectionKey]
        // console.log('_levelSectionKey', _levelSectionKey, _homeAway)
        const teamCount = _.size(sectionTeams)
        const sectionDates_selected = sectionDates && sectionDates[teamCount] ? sectionDates[teamCount] : []
        if (sectionDates_selected) {
          const playGrids = sgs.wpial_home_away[teamCount]
          if (playGrids) {
            for (var allezRetour = 1; allezRetour <= 2; allezRetour++) {
              createMatches(mainDb, sectionTeams, allezRetour, sectionDates_selected, sportInfo, playGrids, allM, _homeAway, gameScoringType)
            }
          }
        }

        if (sectionCrossovers) {

          const sectionCrossoverKey = sectionCrossovers[_levelSectionKey]

          if (!crossoverKeys.includes(_levelSectionKey)) {

            const _sectionCrossover = sectionCrossoverKey.split('_')
            const _levelKey = _sectionCrossover[0]
            const _sectionKey = _sectionCrossover[1]
            const _crossoverSectionTeams = sections[_sectionKey]
            const teamCount = _.size(_crossoverSectionTeams)
            const selectedCrossoverDates = crossSectionDates && crossSectionDates[teamCount] ? crossSectionDates[teamCount] : []
            const crossoverGrids = sgs.crossover[teamCount]
            // const playGrids = sgs.wpial_home_away[teamCount]
            if (crossoverGrids) {
              const _homeAway = homeAways && homeAways[_levelSectionKey] ? homeAways[_levelSectionKey] : homeAway
              createCrossoverMatches(sectionTeams, _crossoverSectionTeams, allezRetour, selectedCrossoverDates, sportInfo, crossoverGrids, allCM, _homeAway, gameScoringType)
              crossoverKeys.push(sectionCrossoverKey)
            }
          }
        }
      })
    })
  }


  // const aaa = _.find(allM, { key: 'Plum-Gateway' })
  // const bbb = _.find(allM, { key: 'Gateway-Plum' })
  // console.log('Plum-Gateway', aaa, aaa.startDate)
  // console.log('Gateway-Plum', bbb, bbb.startDate)

  return {
    matches,
    matches_combined: allM,
    crossoverMatches: allCM,
  }
}

const createMatches = (mainDb, teams, allezRetour, selectedDates, sportInfo, playGrids, allM, homeAway, gameScoringType) => {

  // loop the grids
  let pdi = (allezRetour === 2) ? Object.keys(playGrids).length : 0

  if (playGrids) {
    _.forEach(playGrids, (gridMatches) => {
      if (gridMatches) {
        _.forEach(gridMatches, (gridMatch) => { // gridMatch = {h: 1, a: 6}
          const _match = getMatch(teams, gridMatch, homeAway, allezRetour)
          const newMatch = createMatch(_match, selectedDates[pdi], sportInfo.startTime, gameScoringType)
          const _key = createFsDocKey_alt(mainDb)
          allM[_key] = newMatch
        })
      }
      pdi++
    })
  }

}

const createCrossoverMatches = (teams, crossoverTeams, allezRetour, selectedDates, sportInfo, playGrids, allM, homeAway, gameScoringType) => {

  let _isHome = true

  if (playGrids) {
    let pdi = (allezRetour === 2) ? Object.keys(playGrids).length : 0
    _.forEach(teams, (team) => {
      const { position, levels } = team ?? {}
      _.forEach(playGrids, (gridMatches, playDateNumber) => {
        if (gridMatches) {
          const gridMatch = gridMatches[position + 1]
          const { o } = gridMatch ?? {}
          const opponent = getTeamByPosition(crossoverTeams, o)
          const newMatch = {
            home: _isHome ? team : opponent,
            away: _isHome ? opponent : team,
            startDate: selectedDates[playDateNumber - 1],
            levels: levels,
            sections: _mediaHeaders.nonSection,
            isCrossover: true,
            teams: [team.id, opponent.id],
          }
          const _key = database_fns.get_docKey()
          allM[_key] = newMatch
          _isHome = !_isHome
        }
        pdi++
      })
    })
  }
}

const getMatch = (teams, gridMatch, homeAway, allezRetour) => {
  const newMatch = {
    home: { ...getHomeAway(homeAway, teams, gridMatch, allezRetour, true) },
    away: { ...getHomeAway(homeAway, teams, gridMatch, allezRetour, false) },
  }
  return newMatch
}

const createMatch = (newMatch, startDate, startTime, gameScoringType) => {

  newMatch.startDate = startDate ? startDate : '??????'
  newMatch.startTime = startTime

  switch (gameScoringType) {
    case gameScoringTypes.match:
    case gameScoringTypes.matchPoints:
      newMatch.bestOf = true
      newMatch.setCount = 5
      break;
    default:
    // nothing
  }

  newMatch.key = newMatch.away.name + '-' + newMatch.home.name
  newMatch.teams = [newMatch.home.id, newMatch.away.id]

  if (newMatch.away.levels === newMatch.home.levels) {
    newMatch.levels = newMatch.home.levels
  } else {
    newMatch.levels = _mediaHeaders.nonLevel
  }
  if (newMatch.away.sections === newMatch.home.sections) {
    newMatch.sections = newMatch.home.sections
  } else {
    newMatch.sections = _mediaHeaders.nonSection
  }
  return newMatch
}

const getHomeAway = (homeAway, teams, gridMatch, allezRetour, isHome) => {
  if (homeAway) {
    if (isHome) {
      if (allezRetour === 1) {
        return getTeamByPosition(teams, gridMatch.a)
      } else {
        return getTeamByPosition(teams, gridMatch.h)
      }
    } else {
      if (allezRetour === 1) {
        return getTeamByPosition(teams, gridMatch.h)
      } else {
        return getTeamByPosition(teams, gridMatch.a)
      }
    }
  } else {
    if (isHome) {
      if (allezRetour === 1) {
        return getTeamByPosition(teams, gridMatch.h)
      } else {
        return getTeamByPosition(teams, gridMatch.a)
      }
    } else {
      if (allezRetour === 1) {
        return getTeamByPosition(teams, gridMatch.a)
      } else {
        return getTeamByPosition(teams, gridMatch.h)
      }
    }
  }
}


const getTeamByPosition = (teams, teamNumber, withParents) => {

  const rTeam = {}

  const team = _.find(teams, (team) => team.position + 1 === teamNumber);

  if (team) {
    const { id, _itemKey } = team
    rTeam.id = id ? id : _itemKey
    rTeam._itemKey = id ? id : _itemKey
    rTeam.name = team.name
    rTeam.sections = team.sections
    rTeam.levels = team.levels
    if (withParents) {
      rTeam.organizations = team.parentKeys.organizations
      rTeam.districts = team.parentKeys.districts
    }
  }

  return rTeam
}
